import React, {useEffect, useState} from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { connect } from 'react-redux'
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { confirmAlert } from "react-confirm-alert";

import GlossaryFilters from "./_filters";
import { FL_DESCRIPTION, FL_TERM } from "../../components/i18n/formLabels";
import { ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, LB_ACTIONS, LIST, NO, NO_DATA_FOUND, UPDATE_GLOSSARY_LABEL, YES } from "../../components/i18n/i18n";
import { setTableParams } from "../../redux/actions/generalActions/listActions";
import { remove, search } from "../../redux/actions/xooka/glossaryActions"
import { setFilter } from '../../redux/actions/generalActions/listActions'
import { setItem, setForm } from '../../redux/actions/generalActions/formActions'
import { setViewMode, setLoading } from '../../redux/actions/generalActions/mainActions'
import { GenericTableButton} from "../../components/buttons/buttonsActions";
import { TT_DELETE, TT_EDIT } from "../../components/i18n/toolTips";
import { glossaryService } from "../../jwt/_services/xooka/glossaryService";

const GlossaryList = props => {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listState
    const [disabledUpdateGlossary, setDissabledUpdateGlossary] = useState( window.localStorage.getItem('updateGlossary') == '0' || window.localStorage.getItem('updateGlossary') == null)

    useEffect( () => {
        if(!filter)
            props.setFilter({ term: null });
    },[] )

    useEffect(() => {
        if(!filter)
            return

        refreshDataList();
    },[filter, pageIndex, pageSize] )

    const refreshDataList = () => props.search(pageIndex, pageSize, filter)

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage;
        props.setTableParams( sizePerPage, currentIndex, page );
    };

    const confirmDelete = id => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{ARE_YOU_SHURE_MSG}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                props.remove(id)
                window.localStorage.setItem('updateGlossary', '1')
                setDissabledUpdateGlossary(false)
                onClose();
            }}>
                {YES}
            </button>
        </div>
    });

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={ () => {
            props.setViewMode('FORM');
            props.setItem(row);
            props.setForm(true, false, false);
        } }/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row?.id)}/>
    </>

    const handleUpdateGlossary = () => {
        props.setLoading(true)
        glossaryService.saveItem()
            .then(result => {
                window.localStorage.setItem('updateGlossary', '0')
                setDissabledUpdateGlossary(true)
            })
            .catch(error => console.log("Error al guardar el glosario", error))
            .finally(() => props.setLoading(false))
    }

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'term',
            text: `${FL_TERM}`,
        },
        {
            dataField: 'description',
            text: `${FL_DESCRIPTION}`,
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '150px'},
            formatter: actionsFormatter
        }
    ]

    return(<Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <GlossaryFilters />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={ listDomainObjects || [] }
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>

        <CardBody className="border-top">
            <Row>
                <Col className='text-lg-left'>
                    <div className="float-right">
                        <Button
                            type="button"
                            className="btn-add ml-auto ml-2"
                            disabled={ disabledUpdateGlossary }
                            onClick={ handleUpdateGlossary }
                        >
                            {UPDATE_GLOSSARY_LABEL}
                        </Button>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Card>)
}

const mapStateToProps = state => ({
    listState : state.listProps,
})
const mapActionsToProps = ({
    setTableParams,
    setFilter,
    remove,
    search,
    setItem,
    setForm,
    setViewMode,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(GlossaryList)